// src/BubbleMenu.tsx
import { BubbleMenuPlugin, BubbleMenuPluginKey } from "@golden/tiptap-base";
import React, { useEffect, useRef } from "react";
var BubbleMenu = React.memo((props) => {
  const element = useRef(null);
  useEffect(() => {
    const { editor, tippyOptions, type } = props;
    editor.registerPlugin(BubbleMenuPlugin({
      editor,
      element: element.current,
      tippyOptions,
      type
    }));
    return () => {
      editor.unregisterPlugin(BubbleMenuPluginKey);
    };
  }, []);
  return /* @__PURE__ */ React.createElement("div", { ref: element, className: props.className, style: { visibility: "hidden" } }, props.children);
});

// src/useEditor.ts
import { useEffect as useEffect2, useState } from "react";
import { Editor } from "@tiptap/react";
function useForceUpdate() {
  const [, setValue] = useState(0);
  return () => {
    setValue((value) => value + 1);
  };
}
var useEditor = (options = {}, deps = []) => {
  const [editor, setEditor] = useState(null);
  const forceUpdate = useForceUpdate();
  useEffect2(() => {
    let isMounted = true;
    void (async () => {
      const extensions = options.extensions ? await options.extensions() : void 0;
      const instance = new Editor({ ...options, extensions });
      setEditor(instance);
      instance.on("transaction", () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (isMounted) {
              forceUpdate();
            }
          });
        });
      });
    })();
    return () => {
      editor?.destroy();
      isMounted = false;
    };
  }, deps);
  return editor;
};

// src/index.ts
export * from "@golden/tiptap-base";
import { BubbleMenu as BubbleMenu2, EditorContent } from "@tiptap/react";
export {
  BubbleMenu,
  EditorContent,
  BubbleMenu2 as TiptapBubbleMenu,
  useEditor
};
//# sourceMappingURL=index.js.map